import type {
  // ProjectJsonldReadCollectionCluster,
  // ProjectJsonldReadCollectionCollaborator,
  // ProjectJsonldReadCollectionPropertyOffer,
  // ProjectJsonldReadCollectionPropertySearch,
  ProjectJsonldReadItemClusterItem,
  ProjectJsonldReadItemCollaboratorItem,
  ProjectJsonldReadItemPeople,
  ProjectJsonldReadItemPropertyOffer,
  ProjectJsonldReadItemPropertySearch,
} from "@/networking/api"
import type { LocalRefLabel } from "@/utils/i18n/t11n"

export type RelatedProject =
  // | ProjectJsonldReadCollectionCluster
  // | ProjectJsonldReadCollectionCollaborator
  // | ProjectJsonldReadCollectionCollaborator
  // | ProjectJsonldReadCollectionPropertyOffer
  // | ProjectJsonldReadCollectionPropertySearch
  (
    | ProjectJsonldReadItemClusterItem
    | ProjectJsonldReadItemCollaboratorItem
    | ProjectJsonldReadItemPeople
    | ProjectJsonldReadItemPropertyOffer
    | ProjectJsonldReadItemPropertySearch
  ) & {
    order?: number | null
    role?: LocalRefLabel | null
  }

/**
export type ProjectRelation =
  | ProjectClusterJsonldReadCollectionCluster
  | ProjectClusterJsonldReadItemClusterItem
  | ProjectCollaboratorJsonldReadCollectionCollaborator
  | ProjectCollaboratorJsonldReadItemCollaboratorItem
  | ProjectPeopleJsonldReadCollectionPeople
  | ProjectPeopleJsonldReadItemPeople
  | ProjectPropertyOfferJsonldReadCollectionPropertyOffer
  | ProjectPropertyOfferJsonldReadItemPropertyOffer
  | ProjectPropertySearchJsonldReadCollectionPropertySearch
  | ProjectPropertySearchJsonldReadItemPropertySearch
*/

export const PROJECTS_SORT_COLUMN_DEFAULT = "created_at"
export const PROJECTS_SORT_ORDER_DEFAULT = "desc"

export const ProjectStatus = {
  ACTIVE: "active",
  ARCHIVE: "archive",
} as const
export type ProjectStatus = (typeof ProjectStatus)[keyof typeof ProjectStatus]

export const ProjectSearchStatus = {
  ACTIVE: "active",
  INACTIVE: "inactive",
} as const
export type ProjectSearchStatus = (typeof ProjectSearchStatus)[keyof typeof ProjectSearchStatus]

export const ProjectOfferStatus = {
  // Closed
  OTHER: "other",
  CLOSED: "closed",
  SELL_RENT_AGENT: "sell_rent_agent",
  SELL_RENT_OWNER: "sell_rent_owner",
  SELL_RENT_OTHER_AGENT: "sell_rent_other_agent",
  REMOVE_AGENT: "removed_agent",
  REMOVE_OWNER: "removed_owner",
  SELL_RENT_CANCELLED: "sell_rent_cancelled",
  // Deleted
  DELETED: "deleted",
  // In Progress
  GENERAL: "general",
  MARKET: "market",
  DELEGATION: "delegation",
  PROSPECTING: "prospecting",
  VALUATION: "valuation",
  OFF_MARKET: "off_market",
  IN_PROGRESS: "in_progress",
  // Stand-by
  OFFER: "offer",
  STANDBY: "standby",
  WAITING_AGREEMENT: "waiting_agreement",
  AGREEMENT_ENDED: "agreement_ended",
  PROCESSING_SALE: "processing_sale",
  WAITING_CONTRACT: "waiting_contract",
  PENDING_APPROVAL: "pending_approval",
} as const
export type ProjectOfferStatus = (typeof ProjectOfferStatus)[keyof typeof ProjectOfferStatus]

export const ProjectType = {
  OFFER: "offer",
  REQUEST: "request",
  SERVICE: "service",
} as const
export type ProjectType = (typeof ProjectType)[keyof typeof ProjectType]

export const ProjectSubtype = {
  REAL_ESTATE: "real_estate",
  FAMILY_OFFICE: "family_office",
  ART: "art",
  PRIVATE_FLIGHT: "private_flight",
  YACHTING: "yachting",
  CLASSIC_CARS: "classic_cars",
  CONCIERGE: "concierge",
  EVENTS: "events",
} as const
export type ProjectSubtype = (typeof ProjectSubtype)[keyof typeof ProjectSubtype]
